export default "__VITE_ASSET__CdYAi69a__"